import { getAxiosMultiPartInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Company routes
 * ----------------------------
 */
export const getCompany = (query, force = false, callback) => {
    cachiosInstance.get(`/company?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const newCompany = (data, callback) => {
    getAxiosMultiPartInstanceApi().post(`/company`, data)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const updateCompany = (companyId, data, callback) => {
    getAxiosMultiPartInstanceApi().post(`/company/${companyId}?_method=PUT`, data)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};